import { useEntityList } from '@backstage/plugin-catalog-react';
import { DocsGrid, Group } from './docs-grid';

export type { Group } from './docs-grid';

export const CustomEntityListDocsGrid = ({ groups }: { groups?: Group[] }) => {
  const { entities } = useEntityList();

  return <DocsGrid entities={entities} groups={groups} />;
};
